import {
  Component,
  computed,
  inject,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatIconButton } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatDivider } from "@angular/material/divider";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { RouterLink } from "@angular/router";
import {
  IconComponent,
  ButtonComponent,
  ButtonClass,
} from "@claas/claas-ui-components";
import { TranslateModule } from "@ngx-translate/core";
import { AuthService } from "../../../../shared/data/auth.service";
import { userContextStore } from "../../../../shared/data/user-context.store";
import { ResponsiveService } from "../../../../shared/util/responsive.service";
import { footerLegalLinksStore } from "../../../coremedia/navigation/data/footer-legal-links.store";
import { ChangeCountryDialogComponent } from "../change-country-dialog/change-country-dialog";
import { ChangeLanguageDialogComponent } from "../change-language-dialog/change-language-dialog";

@Component({
  selector: "claas-user-overlay",
  templateUrl: "./user-overlay.html",
  styleUrls: ["./user-overlay.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatIconButton,
    MatDivider,
    RouterLink,
    IconComponent,
    ButtonComponent,
    TranslateModule,
  ],
})
export class UserOverlayComponent {
  protected readonly store = inject(userContextStore);
  protected readonly footerLinksStore = inject(footerLegalLinksStore);
  private readonly dialog = inject(MatDialog);
  private readonly authService = inject(AuthService);
  private readonly responsiveService = inject(ResponsiveService);

  protected readonly buttonClass = ButtonClass;

  protected readonly isMobilePanel = this.responsiveService.isMobilePhone;
  protected readonly isTabletPanel = this.responsiveService.isTablet;

  protected readonly userInitials = computed(() => {
    const name = this.store.userName();
    if (!name) return "?";
    return name
      .split(" ")
      .filter(Boolean)
      .map((part) => part[0].toUpperCase())
      .slice(0, 2)
      .join("");
  });

  @ViewChild(MatMenuTrigger) private readonly menuTrigger!: MatMenuTrigger;

  protected openChangePassword(): void {
    // TODO: implement once password change flow is available
  }

  protected openChangeCountry(): void {
    this.dialog.open(ChangeCountryDialogComponent, {
      width: "400px",
      disableClose: false,
    });
  }

  protected openChangeLanguage(): void {
    this.dialog.open(ChangeLanguageDialogComponent, {
      width: "400px",
      disableClose: false,
    });
  }

  protected logout(): void {
    this.menuTrigger?.closeMenu();
    void this.authService.logout();
  }
}
